/**
 * Default Amazon SP-API marketplace IDs for OAuth / authorization redirect.
 * Used with `region` so the backend can build the correct Seller Central URL.
 * @see https://developer-docs.amazon.com/sp-api/docs/marketplace-ids
 */
var DEFAULT_MARKETPLACE_ID_BY_REGION = {
  NA: 'ATVPDKIKX0DER',
  EU: 'A1F83G8C2ARO7P',
  IN: 'A21TJRUUN4KGV',
  ME: 'A2VIGQ35RCS4UG',
  FE: 'A1VC38T7YXB528'
}

/** Selected when authorizing all marketplaces in a region (one regional OAuth). */
export var ALL_MARKETPLACES_SELECTION = 'ALL'

/** Marketplace pickers for connect / onboarding (region + marketplace on OAuth). */
export var AMAZON_CONNECT_MARKETPLACES_BY_REGION = {
  NA: [
    { label: 'United States', code: 'US', marketplaceId: 'ATVPDKIKX0DER' },
    { label: 'Canada', code: 'CA', marketplaceId: 'A2EUQ1WTGCTBG2' },
    { label: 'Mexico', code: 'MX', marketplaceId: 'A1AM78C64UM0Y8' },
    { label: 'Brazil', code: 'BR', marketplaceId: 'A2Q3Y263D00KWC' }
  ],
  EU: [
    { label: 'United Kingdom', code: 'UK', marketplaceId: 'A1F83G8C2ARO7P' },
    { label: 'Germany', code: 'DE', marketplaceId: 'A1PA6795UKMFR9' },
    { label: 'France', code: 'FR', marketplaceId: 'A13V1IB3VIYZZH' },
    { label: 'Spain', code: 'ES', marketplaceId: 'A1RKKUPIHCS9HS' },
    { label: 'Italy', code: 'IT', marketplaceId: 'APJ6JRA9NG5V4' },
    { label: 'Netherlands', code: 'NL', marketplaceId: 'A1805IZSGTT6HS' },
    { label: 'Belgium', code: 'BE', marketplaceId: 'AMEN7PMS3EDWL' },
    { label: 'Sweden', code: 'SE', marketplaceId: 'A2NODRKZP88ZB9' },
    { label: 'Poland', code: 'PL', marketplaceId: 'A1C3SOZRARQ6R3' },
    { label: 'South Africa', code: 'ZA', marketplaceId: 'AE08WJ6YKNBMC' }
  ],
  ME: [
    { label: 'United Arab Emirates', code: 'AE', marketplaceId: 'A2VIGQ35RCS4UG' },
    { label: 'Saudi Arabia', code: 'SA', marketplaceId: 'A17E79C6D8DWNP' },
    { label: 'Egypt', code: 'EG', marketplaceId: 'ARBP9OOSHTCHU' },
    { label: 'Turkey', code: 'TR', marketplaceId: 'A33AVAJ2PDY3EV' }
  ],
  IN: [
    { label: 'India', code: 'IN', marketplaceId: 'A21TJRUUN4KGV' }
  ],
  FE: [
    { label: 'Japan', code: 'JP', marketplaceId: 'A1VC38T7YXB528' },
    { label: 'Australia', code: 'AU', marketplaceId: 'A39IBJ37TRP1C6' },
    { label: 'Singapore', code: 'SG', marketplaceId: 'A19VAU5U5O7RUS' }
  ]
}

export function defaultMarketplaceIdForRegion (region) {
  if (region == null || region === '') return DEFAULT_MARKETPLACE_ID_BY_REGION.NA
  var key = String(region).toUpperCase()
  return DEFAULT_MARKETPLACE_ID_BY_REGION[key] || DEFAULT_MARKETPLACE_ID_BY_REGION.NA
}

/**
 * @param {string} region - NA | EU | IN | ME | FE
 * @param {string} [marketplaceOverride] - SP-API marketplace id; wins over default for region
 */
export function amazonAuthorizationQueryMarketplace (region, marketplaceOverride) {
  if (marketplaceOverride != null && String(marketplaceOverride).trim() !== '') {
    return String(marketplaceOverride).trim()
  }
  return defaultMarketplaceIdForRegion(region)
}

/** Lookup chip option by SP-API marketplace id (e.g. Australia A39IBJ37TRP1C6). */
export function isAllMarketplacesSelection (marketplaceId) {
  return marketplaceId === ALL_MARKETPLACES_SELECTION
}

export function regionMarketplaceCodes (region) {
  var key = region == null ? '' : String(region).toUpperCase()
  var list = AMAZON_CONNECT_MARKETPLACES_BY_REGION[key]
  if (!list) return []
  return list.map(function (o) { return o.code })
}

export function regionAllMarketplacesLabel (region) {
  var codes = regionMarketplaceCodes(region)
  if (!codes.length) return 'All marketplaces'
  return 'All marketplaces (' + codes.join(', ') + ')'
}

export function findConnectMarketplaceOption (region, marketplaceId) {
  if (!region || !marketplaceId || isAllMarketplacesSelection(marketplaceId)) return null
  var key = String(region).toUpperCase()
  var list = AMAZON_CONNECT_MARKETPLACES_BY_REGION[key]
  if (!list) return null
  var id = String(marketplaceId).trim()
  for (var i = 0; i < list.length; i++) {
    if (list[i].marketplaceId === id) return list[i]
  }
  return null
}



// WEBPACK FOOTER //
// ./src/utils/amazonSellingPartnerOAuth.js